// 点击命中判定:与渲染层"后绘制者在最上层"保持一致
// 渲染时角色按 y 升序绘制(y 大者后绘制、在最上层);同 y 时数组靠后者也在最上层

export interface PickableAgent {
  id: string;
  x: number;
  y: number;
}

/**
 * 在 (x, y)(单位为格)处点击时,返回命中的最上层角色。
 * 候选半径 radius 格;候选之间按 y 大优先、同 y 时下标大优先。
 */
export function pickTopmostAgent<T extends PickableAgent>(
  agents: T[],
  x: number,
  y: number,
  radius = 0.8,
): T | null {
  let best: T | null = null;
  let bestIdx = -1;
  for (let i = 0; i < agents.length; i++) {
    const a = agents[i];
    const d = Math.hypot(a.x + 0.5 - x, a.y + 0.5 - y);
    if (d >= radius) continue;
    if (!best) {
      best = a;
      bestIdx = i;
      continue;
    }
    if (a.y > best.y || (a.y === best.y && i > bestIdx)) {
      best = a;
      bestIdx = i;
    }
  }
  return best;
}
